import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const KullaniciYonetimi = () => {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [message, setMessage] = useState({ type: '', text: '' });

  const [newUser, setNewUser] = useState({
    username: '',
    password: '',
    full_name: '',
    email: '',
    role: 'atolye'
  });

  const [passwordForm, setPasswordForm] = useState({
    new_password: '',
    confirm_password: ''
  });

  const isAdmin = () => user?.role === 'admin';

  useEffect(() => {
    if (isAdmin()) {
      fetchUsers();
    }
  }, []);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/auth/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(response.data);
    } catch (error) {
      showMessage('error', 'Kullanıcılar yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: '', text: '' }), 5000);
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    if (newUser.password.length < 6) {
      showMessage('error', 'Şifre en az 6 karakter olmalıdır');
      return;
    }
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API}/auth/register`, newUser, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showMessage('success', 'Kullanıcı eklendi');
      setShowAddModal(false);
      setNewUser({ username: '', password: '', full_name: '', email: '', role: 'atolye' });
      fetchUsers();
    } catch (error) {
      showMessage('error', error.response?.data?.detail || 'Hata oluştu');
    }
  };

  const handleDeleteUser = async (userId, username) => {
    if (userId === user.id) {
      showMessage('error', 'Kendinizi silemezsiniz');
      return;
    }
    if (!window.confirm(`"${username}" silinsin mi?`)) return;
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/auth/users/${userId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showMessage('success', 'Kullanıcı silindi');
      fetchUsers();
    } catch (error) {
      showMessage('error', 'Silinemedi');
    }
  };

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API}/auth/users/${selectedUser.id}`, {
        full_name: selectedUser.full_name,
        email: selectedUser.email,
        role: selectedUser.role
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showMessage('success', 'Güncellendi');
      setShowEditModal(false);
      fetchUsers();
    } catch (error) {
      showMessage('error', 'Güncellenemedi');
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (passwordForm.new_password !== passwordForm.confirm_password) {
      showMessage('error', 'Şifreler eşleşmiyor');
      return;
    }
    if (passwordForm.new_password.length < 6) {
      showMessage('error', 'Şifre en az 6 karakter olmalı');
      return;
    }
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API}/auth/reset-password/${selectedUser.id}`, {
        password: passwordForm.new_password
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showMessage('success', 'Şifre sıfırlandı');
      setShowPasswordModal(false);
      setPasswordForm({ new_password: '', confirm_password: '' });
    } catch (error) {
      showMessage('error', 'Şifre sıfırlanamadı');
    }
  };

  const getRoleName = (role) => {
    const roles = { admin: 'Yönetici', muhendis: 'Mühendis', muhasebe: 'Muhasebe', atolye: 'Atölye' };
    return roles[role] || role;
  };

  const getRoleStyle = (role) => {
    const styles = {
      admin: { background: '#fee2e2', color: '#991b1b' },
      muhendis: { background: '#dbeafe', color: '#1e40af' },
      muhasebe: { background: '#fef3c7', color: '#92400e' },
      atolye: { background: '#dcfce7', color: '#166534' }
    };
    return styles[role] || { background: '#f1f5f9', color: '#475569' };
  };

  if (!isAdmin()) {
    return <div style={{textAlign:'center',padding:'50px'}}><h2>🔒 Erişim Reddedildi</h2><p>Bu sayfa sadece yöneticiler içindir.</p></div>;
  }

  if (loading) return <div>Yükleniyor...</div>;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">👥 Kullanıcı Yönetimi</h1>
        <button className="btn btn-primary" onClick={() => setShowAddModal(true)}>+ Yeni Kullanıcı</button>
      </div>

      {message.text && (
        <div style={{padding:'12px',marginBottom:'20px',borderRadius:'8px',background:message.type==='success'?'#dcfce7':'#fee2e2',color:message.type==='success'?'#166534':'#991b1b'}}>
          {message.text}
        </div>
      )}

      <div className="card">
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead>
            <tr style={{borderBottom:'2px solid #e2e8f0'}}>
              <th style={{textAlign:'left',padding:'12px'}}>Ad Soyad</th>
              <th style={{textAlign:'left',padding:'12px'}}>Kullanıcı Adı</th>
              <th style={{textAlign:'left',padding:'12px'}}>E-posta</th>
              <th style={{textAlign:'left',padding:'12px'}}>Yetki</th>
              <th style={{textAlign:'right',padding:'12px'}}>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} style={{borderBottom:'1px solid #e2e8f0'}}>
                <td style={{padding:'12px'}}>{u.full_name}</td>
                <td style={{padding:'12px'}}>{u.username}</td>
                <td style={{padding:'12px'}}>{u.email}</td>
                <td style={{padding:'12px'}}><span style={{padding:'4px 12px',borderRadius:'20px',fontSize:'12px',...getRoleStyle(u.role)}}>{getRoleName(u.role)}</span></td>
                <td style={{padding:'12px',textAlign:'right'}}>
                  <button onClick={() => {setSelectedUser(u);setShowEditModal(true);}} style={{marginRight:'8px',padding:'6px 12px',border:'none',borderRadius:'6px',background:'#f1f5f9',cursor:'pointer'}}>✏️</button>
                  <button onClick={() => {setSelectedUser(u);setShowPasswordModal(true);}} style={{marginRight:'8px',padding:'6px 12px',border:'none',borderRadius:'6px',background:'#fef3c7',cursor:'pointer'}}>🔑</button>
                  {u.id !== user.id && <button onClick={() => handleDeleteUser(u.id, u.username)} style={{padding:'6px 12px',border:'none',borderRadius:'6px',background:'#fee2e2',cursor:'pointer'}}>🗑️</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Yeni Kullanıcı Modal */}
      {showAddModal && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'white',padding:'32px',borderRadius:'16px',width:'400px'}}>
            <h2>➕ Yeni Kullanıcı</h2>
            <form onSubmit={handleAddUser}>
              <div style={{marginBottom:'16px'}}><label>Kullanıcı Adı *</label><input type="text" value={newUser.username} onChange={(e)=>setNewUser({...newUser,username:e.target.value})} required style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px'}}/></div>
              <div style={{marginBottom:'16px'}}><label>Şifre *</label><input type="password" value={newUser.password} onChange={(e)=>setNewUser({...newUser,password:e.target.value})} required style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px'}}/></div>
              <div style={{marginBottom:'16px'}}><label>Ad Soyad *</label><input type="text" value={newUser.full_name} onChange={(e)=>setNewUser({...newUser,full_name:e.target.value})} required style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px'}}/></div>
              <div style={{marginBottom:'16px'}}><label>E-posta</label><input type="email" value={newUser.email} onChange={(e)=>setNewUser({...newUser,email:e.target.value})} style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px'}}/></div>
              <div style={{marginBottom:'16px'}}>
                <label>Yetki</label>
                <select value={newUser.role} onChange={(e)=>setNewUser({...newUser,role:e.target.value})} style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px'}}>
                  <option value="atolye">Atölye</option>
                  <option value="muhendis">Mühendis</option>
                  <option value="muhasebe">Muhasebe</option>
                  <option value="admin">Yönetici</option>
                </select>
              </div>
              <div style={{display:'flex',gap:'12px'}}><button type="submit" className="btn btn-primary" style={{flex:1}}>Ekle</button><button type="button" onClick={()=>setShowAddModal(false)} style={{flex:1,padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px',background:'white',cursor:'pointer'}}>İptal</button></div>
            </form>
          </div>
        </div>
      )}

      {/* Düzenle Modal */}
      {showEditModal && selectedUser && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'white',padding:'32px',borderRadius:'16px',width:'400px'}}>
            <h2>✏️ Kullanıcı Düzenle</h2>
            <form onSubmit={handleUpdateUser}>
              <div style={{marginBottom:'16px'}}><label>Kullanıcı Adı</label><input type="text" value={selectedUser.username} disabled style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px',background:'#f1f5f9'}}/></div>
              <div style={{marginBottom:'16px'}}><label>Ad Soyad</label><input type="text" value={selectedUser.full_name} onChange={(e)=>setSelectedUser({...selectedUser,full_name:e.target.value})} style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px'}}/></div>
              <div style={{marginBottom:'16px'}}><label>E-posta</label><input type="email" value={selectedUser.email||''} onChange={(e)=>setSelectedUser({...selectedUser,email:e.target.value})} style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px'}}/></div>
              <div style={{marginBottom:'16px'}}>
                <label>Yetki</label>
                <select value={selectedUser.role} onChange={(e)=>setSelectedUser({...selectedUser,role:e.target.value})} disabled={selectedUser.id===user.id} style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px'}}>
                  <option value="atolye">Atölye</option>
                  <option value="muhendis">Mühendis</option>
                  <option value="muhasebe">Muhasebe</option>
                  <option value="admin">Yönetici</option>
                </select>
              </div>
              <div style={{display:'flex',gap:'12px'}}><button type="submit" className="btn btn-primary" style={{flex:1}}>Kaydet</button><button type="button" onClick={()=>setShowEditModal(false)} style={{flex:1,padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px',background:'white',cursor:'pointer'}}>İptal</button></div>
            </form>
          </div>
        </div>
      )}

      {/* Şifre Sıfırla Modal */}
      {showPasswordModal && selectedUser && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'white',padding:'32px',borderRadius:'16px',width:'400px'}}>
            <h2>🔑 Şifre Sıfırla</h2>
            <p style={{color:'#64748b',marginBottom:'20px'}}><strong>{selectedUser.full_name}</strong> için yeni şifre</p>
            <form onSubmit={handleResetPassword}>
              <div style={{marginBottom:'16px'}}><label>Yeni Şifre</label><input type="password" value={passwordForm.new_password} onChange={(e)=>setPasswordForm({...passwordForm,new_password:e.target.value})} required style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px'}}/></div>
              <div style={{marginBottom:'16px'}}><label>Şifre Tekrar</label><input type="password" value={passwordForm.confirm_password} onChange={(e)=>setPasswordForm({...passwordForm,confirm_password:e.target.value})} required style={{width:'100%',padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px'}}/></div>
              <div style={{display:'flex',gap:'12px'}}><button type="submit" style={{flex:1,padding:'10px',border:'none',borderRadius:'8px',background:'#f59e0b',color:'white',cursor:'pointer'}}>Sıfırla</button><button type="button" onClick={()=>{setShowPasswordModal(false);setPasswordForm({new_password:'',confirm_password:''});}} style={{flex:1,padding:'10px',border:'1px solid #e2e8f0',borderRadius:'8px',background:'white',cursor:'pointer'}}>İptal</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default KullaniciYonetimi;
